import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueFluxo, TFluxoProcesso } from "../../types/api/geral/fluxo-processo";

export default function SelectFluxoProcesso({
  value,
  onChange,
  required = false,
  error = false,
  possuiBtnLimpar = false,
  multiple = false,
  extraParams = {}
}: SelectSimpleApiQueryProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  const inputLabel = (() => {
    if (!value) return "";
    if (Array.isArray(value)) {
      return value.map((item) => `${item.id} - ${item.nome}`).join(", ");
    } else {
      return `${value.id ?? ""}${value.nome ? ` - ${value.nome}` : ""}`;
    }
  })();

  return (
    <>
      <TextField
        {...{ required, error }}
        label={`Selecionar fluxo`}
        variant="outlined"
        fullWidth
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          input: { readOnly: true }
        }}
        value={inputLabel}
        helperText={error ? "Campo obrigatório" : ""}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentSelectGeneric
            {...{ handleClose, possuiBtnLimpar, multiple, extraParams }}
            title="Selecionar fluxo do processo"
            queryPath="/pesquisar-fluxos-processos"
            getItemKey={(item) => item.id}
            defaultValue={
              multiple
                ? Array.isArray(value) && value.length > 0
                  ? value
                  : [defValueFluxo]
                : value
                  ? value
                  : defValueFluxo
            }
            getItemLabel={(item) => `${item.id} - ${item.nome}`}
            onChange={(value) => {
              onChange(value as TFluxoProcesso);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectSimpleApiQueryProps {
  value: TFluxoProcesso | TFluxoProcesso[];
  onChange: (arg: TFluxoProcesso | null) => void;
  required?: boolean;
  error?: boolean;
  possuiBtnLimpar?: boolean;
  multiple?: boolean;
  extraParams?: { [key: string]: any };
}
